import React, { useEffect, useState } from 'react';
import { getAllNotice, getAllNoticeByCountry, getCountryAssetMasterDataList } from '../api/Services/masterServie';
import { CustomMessage } from '../const/Spinner';
import { enqueueSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../store/CommonSlice';
import { RootState } from '../store/Reduxstore';
import { Entry } from '../types/assetTypes';
import { Button, Card, CardActions, CardContent, Grid, Paper, Typography } from '@mui/material';
import { PAGESEND, PAGESTART } from '../api/endpoint';

interface CountrySearchProps {
  setPathname: (path: string) => void;
}

interface Notice {
    noticeId: number;
    info: string;
    createdAt: string;
    userId: number;
    userName: string;
    currentLocationId: number | null;
    countryName: string | null;
  }
  

const Latest: React.FC = () => {
  const [notices, setNotices] = useState<Notice[]>([]);
  
  const dispatch = useDispatch();
  // useEffect(() => {
  //   // Log the length of notices every time the effect runs
  //   console.log('Notices length:', notices.length);
  
  //   if (notices.length === 0) {
  //     getNoticesList();  // Fetch notices only if the length is 0
  //   }
  // }, [notices]);  // This will run every time `notices` changes
  
  useEffect(() => {
  getNoticesList();
}, []); // Empty dependency array = runs once only

  const getNoticesList = async () => {
    try {
      const response = await getAllNotice();
      console.log(response);  // Log response for debugging
      const { status, data } = response;
  
      if (status.code === 200 && Array.isArray(data)) {
        setNotices(data);
      } else {
        setError("Failed to get Informations.");
      }
    } catch (err) {
      console.error(err); // Log error for debugging
      setError("An error occurred while fetching user history.");
    } finally {
      setLoading(false);
    }
  };


  const userDetails = useSelector((state: RootState) => state.auth);
  const [error, setError] = useState<string | null>(null);

  const [countries, setCurrentLocation] = useState<{ label: string; value: number }[]>([]);
  const [selectedLocationId, setSelectedLocationId] = useState<number>(0); // State to hold selected country ID
  useEffect(() => {
    // Ensure the "Select Country" option is shown by setting the default value to 0
    setSelectedLocationId(0);
  }, [countries]); // Re-run if countries list changes

  useEffect(() => {
    if (countries.length === 0) getCurrentLocationList(1,PAGESEND);
  }, [countries]);

  const getCurrentLocationList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCountryAssetMasterDataList(page, rows, {
        currentLocationId: { value: '', matchMode: 'startsWith' },
      });

      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.currentLocationId, // Location ID
          label: val.countryName, // Country Name
        }));
        updatedData.unshift({ label: '--Select--', value: 0 }); // Default select option

        setCurrentLocation(updatedData); // Update country list
        setSelectedLocationId(updatedData[1]?.value || 0); // Set the first country ID or default
      }
    } catch (error: any) {
      CustomMessage(error?.message, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSelectCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    const selectedCountryId = parseInt(value);
    setSelectedLocationId(selectedCountryId); // Update the selected country ID
    console.log('Selected Country ID:', selectedCountryId);
  };
  const handleSubmit = async () => {
    try {
      let result;
      
      if (selectedLocationId === 0) {
        // If selectedLocationId is 0, fetch all notices
        result = await getAllNotice();
      } else {
        // If selectedLocationId is not 0, fetch notices by country
        result = await getAllNoticeByCountry(selectedLocationId);
      }
  
      // Check if the status code is 200 or 201
     if ((result.status.code === 200 || result.status.code === 201) && result.data.length > 0) {
      CustomMessage(result.status.message, 'success', enqueueSnackbar);
      setNotices(result.data);
      console.log('Notices:', result.data);
    } else if ((result.status.code === 200 || result.status.code === 201) && result.data.length === 0) {
      CustomMessage('No notices found for the selected location.', 'info', enqueueSnackbar);
      setNotices([]);
    } else {
      console.error('Request failed:', result.status.message);
    }

    } catch (error) {
      console.error('Error:', error);
      // Optionally, display an error message using enqueueSnackbar
      CustomMessage('An error occurred while fetching the notices', 'error', enqueueSnackbar);
    }
  };
  

//   return (
//     <div className="country-search-container">
//       <h2>Search Country Info</h2>

//       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
//         {/* Country Dropdown */}
//         <select
//           value={selectedLocationId}
//           onChange={handleSelectCountryChange}
//           required
//         >
//           <option value={0}>Select Country</option>
//           {countries.map((country) => (
//             <option key={country.value} value={country.value}>
//               {country.label}
//             </option>
//           ))}
//         </select>

//         {/* Submit Button */}
//         <button
//         onClick={handleSubmit} // Calls handleSubmit function when clicked
//         style={{ padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white' }}
//     // Disables button if no country is selected
//         >
//         Submit
//         </button>
//         <div>
//             {notices.length > 0 ? (
//                 notices.map((notice, index) => (
//                 <div key={index} style={{ marginTop: '10px', padding: '15px', border: '1px solid #ccc', borderRadius: '5px' }}>
//                     <h4>{notice.info}</h4>
                    
//                 </div>
//                 ))
//             ) : (
//                 <p>No notices available.</p>
//             )}
//             </div>  {/* <-- Add this closing div tag */}
//       </div>
//     </div>
//   );
// };

// return (
//     <div className="country-search-container">
//       <h2>Search Country Info</h2>
  
//       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap' }}>
//         {/* Country Dropdown */}
//         <select
//           value={selectedLocationId}
//           onChange={handleSelectCountryChange}
//           required
//           style={{ marginRight: '10px', padding: '10px' }}
//         >
//           <option value={0}>Select Country</option>
//           {countries.map((country) => (
//             <option key={country.value} value={country.value}>
//               {country.label}
//             </option>
//           ))}
//         </select>
  
//         {/* Submit Button */}
//         <button
//           onClick={handleSubmit} // Calls handleSubmit function when clicked
//           style={{
//             padding: '10px 20px',
//             backgroundColor: '#4CAF50',
//             color: 'white',
//             cursor: 'pointer'
//           }}
//           disabled={selectedLocationId === 0} // Disables button if no country is selected
//         >
//           Submit
//         </button>
//       </div>
  
//       {/* Notices Display */}
//       <div>
//         {notices.length > 0 ? (
//           notices.map((notice, index) => (
//             <div
//               key={index}
//               style={{
//                 marginTop: '10px',
//                 padding: '15px',
//                 border: '1px solid #ccc',
//                 borderRadius: '5px'
//               }}
//             >
//               <h4>{notice.info}</h4>
//               {/* Add more details about the notice as needed */}
              
//             </div>
//           ))
//         ) : (
//           <p>No notices available.</p>
//         )}
//       </div>
//     </div>
//   );
// };  

return (
    <div className="country-search-container">
      <h2>Search Country Info</h2>
  
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '20px',
          justifyContent: 'flex-start', // Aligns items to the start of the row
          gap: '10px' // Adds spacing between the dropdown and button
        }}
      >
        {/* Country Dropdown */}
        {/* <select
            value={selectedLocationId}
            onChange={handleSelectCountryChange}
            required
            style={{
                padding: '10px',
                width: '200px' // Adjust width as needed
        }}
>
  <option value={0}>Select Country</option>
  {countries.map((country) => (
    <option key={country.value} value={country.value}>
      {country.label}
    </option>
  ))}
</select>

  
       
        <button
          onClick={handleSubmit} // Calls handleSubmit function when clicked
          style={{
            padding: '10px 20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            cursor: 'pointer',
            height: '40px' // Ensures the button's height is consistent with the dropdown
          }}
        
        >
          Submit
        </button> */}
        <select
        value={selectedLocationId}
        onChange={handleSelectCountryChange}
        required
        style={{
            padding: '8px 20px', // More padding for better appearance
            width: '220px', // A slightly wider width for the select box
            border: '1px solid #ccc', // Border around the select box
            borderRadius: '5px', // Rounded corners
            fontSize: '16px', // Larger text for readability
            backgroundColor: '#f9f9f9', // Light background color
            color: '#333', // Dark text for contrast
            cursor: 'pointer' // Changes the cursor to indicate it's clickable
        }}
        >
        <option value={0}>Select Country</option>
        {countries.map((country) => (
            <option key={country.value} value={country.value}>
            {country.label}
            </option>
        ))}
        </select>

        {/* Submit Button */}
        <button
        onClick={handleSubmit} // Calls handleSubmit function when clicked
        style={{
            padding: '12px 25px', // Larger padding for the button
            backgroundColor: '#4CAF50', // Green background for the button
            color: 'white', // White text on the button
            cursor: 'pointer', // Pointer cursor on hover
            height: '45px', // Ensures the button's height is consistent with the select dropdown
            border: 'none', // Remove border
            borderRadius: '5px', // Rounded corners to match the select box
            fontSize: '16px', // Larger text for the button
            width: '220px', // Ensure the button width matches the select box width            
            transition: 'background-color 0.3s ease', // Smooth transition on hover
        }}
        
        >
        Submit
        </button>

      </div>
      {/* <div>
   
    <Grid container spacing={2}>
      {notices.length > 0 ? (
        notices.map((notice, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper
              style={{
                padding: '15px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginTop: '10px'
              }}
            >
              <Typography variant="h6" gutterBottom>
                {notice.info}
              </Typography>
             
            </Paper>
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="body1">No notices available.</Typography>
        </Grid>
      )}
    </Grid>
  </div> */}
  <Grid container spacing={3} justifyContent="center">
      {notices.length > 0 ? (
        notices.map((notice, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                '&:hover': {
                  boxShadow: 6, // Hover effect for shadow
                },
                borderRadius: '8px',
                boxShadow: 3,
                transition: '0.3s',
              }}
            >
              <CardContent>
                <Typography variant="h6" component="h4" gutterBottom>
                  {notice.info}
                </Typography>
                <Typography variant="body2">
                  <strong>User:</strong> {notice.userName}
                </Typography>
                <Typography variant="body2">
                  <strong>Location:</strong> {notice.countryName}
                </Typography>
                <Typography variant="body2">
                  <strong>Created At:</strong> {new Date(notice.createdAt).toLocaleString()}
                </Typography>
              </CardContent>

              
            </Card>
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="h6" align="center">
            No notices available.
          </Typography>
        </Grid>
      )}
    </Grid>
  </div>
    // </div>
  );
};  

export default Latest;

